import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { SpecialsPageContentLegacy } from './specials-page-content-legacy';
import { SpecialsPageContentV2 } from './specials-page-content-v2';

export default function SpecialsPage() {
  const flags = useFlags();
  const specialsRedesignEnabled = flags['ecomm.specials-redesign.rollout'] ?? false;

  if (specialsRedesignEnabled) {
    return <SpecialsPageContentV2 />;
  }

  return <SpecialsPageContentLegacy />;
}
